module.exports = __webpack_public_path__ + "img/article_1_7.2b55783b.png";